/* LovePTCGevoL — push sold-out products to the bottom of each collection page (in-stock first). Per-page only: it reorders the cards currently on the page; it does not move sold-out items across pages. Sold-out detection uses the SOLD OUT badge rendered in _product-card-gallery.liquid (.lp-badge--soldout). */
(function () {
  var observer = null;
  var scheduled = false;

  function items() {
    return Array.prototype.slice.call(document.querySelectorAll('.product-grid__item'));
  }

  function isSoldOut(li) {
    if (li.querySelector('.lp-badge--soldout')) return true;
    // fallback: a disabled add-to-cart or an explicit sold-out control
    if (li.querySelector('.add-to-cart-button[disabled], [class*="sold-out"], [class*="sold_out"]')) return true;
    return false;
  }

  function reorder() {
    var list = items();
    if (!list.length) return;
    var parent = list[0].parentElement;
    if (!parent) return;
    var sold = list.filter(isSoldOut);
    if (!sold.length) return;
    // already all at the end? (last N items are exactly the sold ones, in order)
    var tail = list.slice(list.length - sold.length);
    var same = sold.every(function (li, i) { return tail[i] === li; });
    if (same) return;
    if (observer) observer.disconnect();
    sold.forEach(function (li) { parent.appendChild(li); });
    if (observer && parent) observer.observe(parent, { childList: true });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; reorder(); });
  }

  function setup() {
    var list = items();
    if (!list.length) return false;
    var parent = list[0].parentElement;
    if (!parent) return false;
    observer = new MutationObserver(schedule);
    observer.observe(parent, { childList: true });
    reorder();
    return true;
  }

  function boot() {
    if (setup()) return;
    var n = 0;
    var iv = setInterval(function () { if (setup() || ++n > 40) clearInterval(iv); }, 150);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { boot(); });
})();
